import {ARTIST_LIST_ITEMS} from './mock/artist-list';

/* eslint-disable camelcase, quotes */
export default {
    ARTIST_LIST: {
        title: 'Artists | Ringa toi',
        items: ARTIST_LIST_ITEMS
    },
    BUTTON: {
        title: 'Example Button Label',
        url: 'https://unsplash.it/800/600'
    },
    CALL_TO_ACTION_LEFT: {
        data: {
            content: '<h1>First Call to Action</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p><a class="button" href="/#" target="_blank">Button Text</a></p>',
            file: 'https://unsplash.it/800/600',
            content_position: 'left'
        }
    },
    CALL_TO_ACTION_RIGHT: {
        data: {
            content: '<h1>Second Call to Action</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p><a class="button" href="/#" target="_blank">Button Text</a></p>',
            file: 'https://unsplash.it/800/601',
            content_position: 'right'
        }
    },
    CONTENT_SET_ARTIST: {
        items: [
            {
                "name": "Leonhard Beck",
                "type": "person",
                "id": "person-1773",
                "data": {
                    "extras": [],
                    "place_of_death": "",
                    "pe_sym_dod_year": "d.1542",
                    "pe_sym_dob_year": "b.circa 1480",
                    "date_of_birth": "circa 1480",
                    "display_name": "Leonhard Beck",
                    "editorial_tags_disabled": [],
                    "bio_display": "",
                    "user_sym_32": "",
                    "slug": "leonhard-beck",
                    "user_sym_8": "Beck|Male",
                    "vernon_tags_disabled": [],
                    "vernon_tags": [],
                    "place_of_birth": "",
                    "pe_sym_name_lk": "Beck, Leonhard",
                    "editorial_tags": [],
                    "pe_sym_name_kl": "Leonhard Beck",
                    "editorial_tags_hidden": [],
                    "vernon_tags_hidden": [],
                    "id": 1773,
                    "nationality": "German",
                    "image_tags": [],
                    "date_of_death": "1542",
                    "ethnicity": "",
                    "artworks": [
                        {
                            "id": 3559,
                            "name": "Soldiers Trying to Sally from the Town of Hulst",
                            "slug": "soldiers-trying-to-sally-from-the-town-of-hulst",
                            "on_display": "0",
                            "images": {
                                "files": [
                                    {
                                        "tiny": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/tiny/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "xlarge": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/xlarge/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "meta_data": {
                                            "css_colors": [
                                                {
                                                    "color_group": "brown",
                                                    "color_name": "tan",
                                                    "formatted_color_name": "tan",
                                                    "rank": 1,
                                                    "lightness": 69,
                                                    "saturation": 44,
                                                    "hue": 34,
                                                    "presence": 59.52,
                                                    "hex": "d2b48c"
                                                }, {
                                                    "color_group": "gray",
                                                    "color_name": "dimgray",
                                                    "formatted_color_name": "dim gray",
                                                    "rank": 2,
                                                    "lightness": 41,
                                                    "saturation": 0,
                                                    "hue": 0,
                                                    "presence": 17.26,
                                                    "hex": "696969"
                                                }, {
                                                    "color_group": "gray",
                                                    "color_name": "gray",
                                                    "formatted_color_name": "gray",
                                                    "rank": 3,
                                                    "lightness": 50,
                                                    "saturation": 0,
                                                    "hue": 0,
                                                    "presence": 8.09,
                                                    "hex": "808080"
                                                }
                                            ],
                                            "image_tags": [
                                                {
                                                    "image_tag": "Art",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Artwork",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Printmaking",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Illustration",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Painting",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "History",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Visual arts",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Ancient history",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Drawing",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Mythology",
                                                    "status": "auto_verified"
                                                }
                                            ]
                                        },
                                        "small": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "gallery": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "zoom": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "nano": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/nano/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "medium": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/medium/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "thumb": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "id": 2597,
                                        "large": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg"
                                    }
                                ],
                                "count": 1
                            }
                        }, {
                            "id": 3562,
                            "name": "The Battle of Dorneck in Switzerland",
                            "slug": "the-battle-of-dorneck-in-switzerland",
                            "on_display": "0",
                            "images": {
                                "files": [
                                    {
                                        "tiny": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/tiny/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "xlarge": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/xlarge/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "meta_data": {
                                            "css_colors": [
                                                {
                                                    "color_group": "brown",
                                                    "color_name": "tan",
                                                    "formatted_color_name": "tan",
                                                    "rank": 1,
                                                    "lightness": 69,
                                                    "saturation": 44,
                                                    "hue": 34,
                                                    "presence": 60.9,
                                                    "hex": "d2b48c"
                                                }, {
                                                    "color_group": "gray",
                                                    "color_name": "dimgray",
                                                    "formatted_color_name": "dim gray",
                                                    "rank": 2,
                                                    "lightness": 41,
                                                    "saturation": 0,
                                                    "hue": 0,
                                                    "presence": 16.8,
                                                    "hex": "696969"
                                                }, {
                                                    "color_group": "gray",
                                                    "color_name": "gray",
                                                    "formatted_color_name": "gray",
                                                    "rank": 3,
                                                    "lightness": 50,
                                                    "saturation": 0,
                                                    "hue": 0,
                                                    "presence": 5.85,
                                                    "hex": "808080"
                                                }
                                            ],
                                            "image_tags": [
                                                {
                                                    "image_tag": "Art",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Printmaking",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Illustration",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Painting",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Drawing",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Mythology",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Artwork",
                                                    "status": "auto_verified"
                                                }
                                            ]
                                        },
                                        "small": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "gallery": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "zoom": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "nano": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/nano/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "medium": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/medium/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "thumb": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "id": 2600,
                                        "large": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg"
                                    }
                                ],
                                "count": 1
                            }
                        }
                    ]
                }
            }, {
                "name": "Hans Burgkmair the Elder",
                "type": "person",
                "id": "person-80",
                "data": {
                    "extras": [],
                    "place_of_death": "Augsburg/Bavaria/Germany",
                    "pe_sym_dod_year": "d.1531",
                    "pe_sym_dob_year": "b.1473",
                    "date_of_birth": "1473",
                    "display_name": "Hans Burgkmair the Elder",
                    "editorial_tags_disabled": [],
                    "bio_display": "",
                    "user_sym_32": "",
                    "slug": "hans-burgkmair-the-elder",
                    "user_sym_8": "Burgkmair the Elder|Male",
                    "vernon_tags_disabled": [],
                    "vernon_tags": [],
                    "place_of_birth": "Augsburg/Bavaria/Germany",
                    "pe_sym_name_lk": "Burgkmair the Elder, Hans",
                    "editorial_tags": [],
                    "pe_sym_name_kl": "Hans Burgkmair the Elder",
                    "editorial_tags_hidden": [],
                    "vernon_tags_hidden": [],
                    "id": 80,
                    "nationality": "German",
                    "image_tags": [],
                    "date_of_death": "1531",
                    "ethnicity": "",
                    "artworks": [
                        {
                            "id": 3560,
                            "name": "The Assault on Venlo",
                            "slug": "the-assault-on-venlo",
                            "on_display": "0",
                            "images": {
                                "files": [
                                    {
                                        "tiny": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/tiny/11823/18010de2233fb3ce992063da990dbfd2d25b780a.jpg",
                                        "xlarge": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/xlarge/11823/18010de2233fb3ce992063da990dbfd2d25b780a.jpg",
                                        "meta_data": {
                                            "css_colors": [
                                                {
                                                    "color_group": "brown",
                                                    "color_name": "tan",
                                                    "formatted_color_name": "tan",
                                                    "rank": 1,
                                                    "lightness": 69,
                                                    "saturation": 44,
                                                    "hue": 34,
                                                    "presence": 48.32,
                                                    "hex": "d2b48c"
                                                }, {
                                                    "color_group": "brown",
                                                    "color_name": "saddlebrown",
                                                    "formatted_color_name": "saddle brown",
                                                    "rank": 2,
                                                    "lightness": 31,
                                                    "saturation": 76,
                                                    "hue": 25,
                                                    "presence": 14.17,
                                                    "hex": "8b4513"
                                                }, {
                                                    "color_group": "gray",
                                                    "color_name": "dimgray",
                                                    "formatted_color_name": "dim gray",
                                                    "rank": 3,
                                                    "lightness": 41,
                                                    "saturation": 0,
                                                    "hue": 0,
                                                    "presence": 12.14,
                                                    "hex": "696969"
                                                }
                                            ],
                                            "image_tags": [
                                                {
                                                    "image_tag": "Art",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Printmaking",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Artwork",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Illustration",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Painting",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Visual arts",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Drawing",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "History",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Sketch",
                                                    "status": "auto_verified"
                                                }
                                            ]
                                        },
                                        "small": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11823/18010de2233fb3ce992063da990dbfd2d25b780a.jpg",
                                        "gallery": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11823/18010de2233fb3ce992063da990dbfd2d25b780a.jpg",
                                        "zoom": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/11823/18010de2233fb3ce992063da990dbfd2d25b780a.jpg",
                                        "nano": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/nano/11823/18010de2233fb3ce992063da990dbfd2d25b780a.jpg",
                                        "medium": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/medium/11823/18010de2233fb3ce992063da990dbfd2d25b780a.jpg",
                                        "thumb": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11823/18010de2233fb3ce992063da990dbfd2d25b780a.jpg",
                                        "id": 2598,
                                        "large": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/11823/18010de2233fb3ce992063da990dbfd2d25b780a.jpg"
                                    }
                                ],
                                "count": 1
                            }
                        }, {
                            "id": 3561,
                            "name": "Battle Near an Unidentified Town",
                            "slug": "battle-near-an-unidentified-town",
                            "on_display": "0",
                            "images": {
                                "files": [
                                    {
                                        "tiny": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/tiny/11824/5f22406b1bfaf1571fe163edd0b837bd0eeb6f86.jpg",
                                        "xlarge": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/xlarge/11824/5f22406b1bfaf1571fe163edd0b837bd0eeb6f86.jpg",
                                        "meta_data": {
                                            "css_colors": [
                                                {
                                                    "color_group": "brown",
                                                    "color_name": "tan",
                                                    "formatted_color_name": "tan",
                                                    "rank": 1,
                                                    "lightness": 69,
                                                    "saturation": 44,
                                                    "hue": 34,
                                                    "presence": 63.07,
                                                    "hex": "d2b48c"
                                                }, {
                                                    "color_group": "brown",
                                                    "color_name": "sienna",
                                                    "formatted_color_name": "sienna",
                                                    "rank": 2,
                                                    "lightness": 40,
                                                    "saturation": 56,
                                                    "hue": 19,
                                                    "presence": 6.57,
                                                    "hex": "a0522d"
                                                }, {
                                                    "color_group": "gray",
                                                    "color_name": "dimgray",
                                                    "formatted_color_name": "dim gray",
                                                    "rank": 3,
                                                    "lightness": 41,
                                                    "saturation": 0,
                                                    "hue": 0,
                                                    "presence": 14.99,
                                                    "hex": "696969"
                                                }, {
                                                    "color_group": "gray",
                                                    "color_name": "gray",
                                                    "formatted_color_name": "gray",
                                                    "rank": 4,
                                                    "lightness": 50,
                                                    "saturation": 0,
                                                    "hue": 0,
                                                    "presence": 7.03,
                                                    "hex": "808080"
                                                }
                                            ],
                                            "image_tags": [
                                                {
                                                    "image_tag": "Art",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Artwork",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Illustration",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "History",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Painting",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Visual arts",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Printmaking",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Drawing",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Ancient history",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Mythology",
                                                    "status": "auto_verified"
                                                }
                                            ]
                                        },
                                        "small": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11824/5f22406b1bfaf1571fe163edd0b837bd0eeb6f86.jpg",
                                        "gallery": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11824/5f22406b1bfaf1571fe163edd0b837bd0eeb6f86.jpg",
                                        "zoom": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/11824/5f22406b1bfaf1571fe163edd0b837bd0eeb6f86.jpg",
                                        "nano": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/nano/11824/5f22406b1bfaf1571fe163edd0b837bd0eeb6f86.jpg",
                                        "medium": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/medium/11824/5f22406b1bfaf1571fe163edd0b837bd0eeb6f86.jpg",
                                        "thumb": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11824/5f22406b1bfaf1571fe163edd0b837bd0eeb6f86.jpg",
                                        "id": 2599,
                                        "large": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/11824/5f22406b1bfaf1571fe163edd0b837bd0eeb6f86.jpg"
                                    }
                                ],
                                "count": 1
                            }
                        }, {
                            "id": 3559,
                            "name": "Soldiers Trying to Sally from the Town of Hulst",
                            "slug": "soldiers-trying-to-sally-from-the-town-of-hulst",
                            "on_display": "0",
                            "images": {
                                "files": [
                                    {
                                        "tiny": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/tiny/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "xlarge": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/xlarge/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "meta_data": {
                                            "css_colors": [
                                                {
                                                    "color_group": "brown",
                                                    "color_name": "tan",
                                                    "formatted_color_name": "tan",
                                                    "rank": 1,
                                                    "lightness": 69,
                                                    "saturation": 44,
                                                    "hue": 34,
                                                    "presence": 59.52,
                                                    "hex": "d2b48c"
                                                }, {
                                                    "color_group": "gray",
                                                    "color_name": "dimgray",
                                                    "formatted_color_name": "dim gray",
                                                    "rank": 2,
                                                    "lightness": 41,
                                                    "saturation": 0,
                                                    "hue": 0,
                                                    "presence": 17.26,
                                                    "hex": "696969"
                                                }, {
                                                    "color_group": "gray",
                                                    "color_name": "gray",
                                                    "formatted_color_name": "gray",
                                                    "rank": 3,
                                                    "lightness": 50,
                                                    "saturation": 0,
                                                    "hue": 0,
                                                    "presence": 8.09,
                                                    "hex": "808080"
                                                }
                                            ],
                                            "image_tags": [
                                                {
                                                    "image_tag": "Art",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Artwork",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Printmaking",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Illustration",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Painting",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "History",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Visual arts",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Ancient history",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Drawing",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Mythology",
                                                    "status": "auto_verified"
                                                }
                                            ]
                                        },
                                        "small": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "gallery": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "zoom": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "nano": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/nano/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "medium": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/medium/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "thumb": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg",
                                        "id": 2597,
                                        "large": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/11821/7ef8d94400fe76dd696c9c399dbcef2861b9195f.jpg"
                                    }
                                ],
                                "count": 1
                            }
                        }, {
                            "id": 3562,
                            "name": "The Battle of Dorneck in Switzerland",
                            "slug": "the-battle-of-dorneck-in-switzerland",
                            "on_display": "0",
                            "images": {
                                "files": [
                                    {
                                        "tiny": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/tiny/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "xlarge": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/xlarge/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "meta_data": {
                                            "css_colors": [
                                                {
                                                    "color_group": "brown",
                                                    "color_name": "tan",
                                                    "formatted_color_name": "tan",
                                                    "rank": 1,
                                                    "lightness": 69,
                                                    "saturation": 44,
                                                    "hue": 34,
                                                    "presence": 60.9,
                                                    "hex": "d2b48c"
                                                }, {
                                                    "color_group": "gray",
                                                    "color_name": "dimgray",
                                                    "formatted_color_name": "dim gray",
                                                    "rank": 2,
                                                    "lightness": 41,
                                                    "saturation": 0,
                                                    "hue": 0,
                                                    "presence": 16.8,
                                                    "hex": "696969"
                                                }, {
                                                    "color_group": "gray",
                                                    "color_name": "gray",
                                                    "formatted_color_name": "gray",
                                                    "rank": 3,
                                                    "lightness": 50,
                                                    "saturation": 0,
                                                    "hue": 0,
                                                    "presence": 5.85,
                                                    "hex": "808080"
                                                }
                                            ],
                                            "image_tags": [
                                                {
                                                    "image_tag": "Art",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Printmaking",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Illustration",
                                                    "status": "auto_verified"
                                                },
                                                {
                                                    "image_tag": "Painting",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Drawing",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Mythology",
                                                    "status": "auto_verified"
                                                }, {
                                                    "image_tag": "Artwork",
                                                    "status": "auto_verified"
                                                }
                                            ]
                                        },
                                        "small": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "gallery": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "zoom": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "nano": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/nano/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "medium": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/medium/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "thumb": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/small/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg",
                                        "id": 2600,
                                        "large": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/11825/c7c4beb589c6c279505e5d2e41d03c5152d9f39f.jpg"
                                    }
                                ],
                                "count": 1
                            }
                        }
                    ]
                }
            }, {
                "name": "Alan Davie",
                "type": "person",
                "id": "person-1354",
                "data": {
                    "extras": [],
                    "place_of_death": "",
                    "pe_sym_dod_year": "d.2014",
                    "pe_sym_dob_year": "b.1920",
                    "date_of_birth": "1920",
                    "display_name": "Alan Davie",
                    "editorial_tags_disabled": [],
                    "bio_display": "",
                    "user_sym_32": "Colour is an Abstraction; 1st hang; 22 Apr 2017; to: 03 Dec 2017",
                    "slug": "alan-davie",
                    "user_sym_8": "Davie|Male",
                    "vernon_tags_disabled": [],
                    "vernon_tags": [],
                    "place_of_birth": "",
                    "pe_sym_name_lk": "Davie, Alan",
                    "editorial_tags": [],
                    "pe_sym_name_kl": "Alan Davie",
                    "editorial_tags_hidden": [],
                    "vernon_tags_hidden": [],
                    "id": 1354,
                    "nationality": "British",
                    "image_tags": [],
                    "date_of_death": "05 Apr 2014",
                    "ethnicity": "",
                    "artworks": [
                        {
                            "id": 3682,
                            "name": "Zurich Improvisations X",
                            "slug": "zurich-improvisations-x",
                            "on_display": "0",
                            "images": []
                        }, {
                            "id": 3705,
                            "name": "For A Brown Magician",
                            "slug": "for-a-brown-magician",
                            "on_display": "0",
                            "images": []
                        }
                    ]
                }
            }, {
                "name": "Ray Fawcett",
                "type": "person",
                "id": "person-1201",
                "data": {
                    "extras": [],
                    "place_of_death": "",
                    "pe_sym_dod_year": "",
                    "pe_sym_dob_year": "b.1934",
                    "date_of_birth": "1934",
                    "display_name": "Ray Fawcett",
                    "editorial_tags_disabled": [],
                    "bio_display": "",
                    "user_sym_32": "",
                    "slug": "ray-fawcett",
                    "user_sym_8": "Fawcett|Male",
                    "vernon_tags_disabled": [],
                    "vernon_tags": [],
                    "place_of_birth": "",
                    "pe_sym_name_lk": "Fawcett, Ray",
                    "editorial_tags": [],
                    "pe_sym_name_kl": "Ray Fawcett",
                    "editorial_tags_hidden": [],
                    "vernon_tags_hidden": [],
                    "id": 1201,
                    "nationality": "British",
                    "image_tags": [],
                    "date_of_death": null,
                    "ethnicity": "",
                    "artworks": [
                        {
                            "id": 3702,
                            "name": "Composition No 7",
                            "slug": "composition-no-7",
                            "on_display": "0",
                            "images": []
                        }
                    ]
                }
            }
        ],
        title: "Artist",
        rows: 1
    },
    CONTENT_SET_ARTWORK: {
        items: [
            {
                "name": "The Artist (1979/2)",
                "type": "artwork",
                "id": "artwork-4973",
                "data": {
                    "id": 4973,
                    "slug": "the-artist",
                    "name": "The Artist",
                    "artists": [
                        {
                            "id": "2566",
                            "display_name": "Roy Dalgarno",
                            "display_name_with_role": "Roy Dalgarno",
                            "slug": "roy-dalgarno"
                        }
                    ],
                    "on_display": false,
                    "image": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/13260/29a922b21d732b0cd19c190a2d14bd4d1703531d.jpg",
                    "material_desc": "etching, aquatint",
                    "credit_line": "Auckland Art Gallery Toi o Tāmaki, purchased 1979"
                }
            }, {
                "name": "The Velvet Jacket (1956/7)",
                "type": "artwork",
                "id": "artwork-2762",
                "data": {
                    "id": 2762,
                    "slug": "the-velvet-jacket",
                    "name": "The Velvet Jacket",
                    "artists": [
                        {
                            "id": "504",
                            "display_name": "Stewart Maclennan",
                            "display_name_with_role": "Stewart Maclennan",
                            "slug": "stewart-maclennan"
                        }
                    ],
                    "on_display": false,
                    "image": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/10993/1788fc635bfd0653f5ff223018b94aa9e266d615.jpg",
                    "material_desc": "watercolour",
                    "credit_line": "Auckland Art Gallery Toi o Tāmaki, purchased 1956"
                }
            }, {
                "name": "The Cove (1977/71/1)",
                "type": "artwork",
                "id": "artwork-4849",
                "data": {
                    "id": 4849,
                    "slug": "the-cove",
                    "name": "The Cove",
                    "artists": [
                        {
                            "id": "504",
                            "display_name": "Stewart Maclennan",
                            "display_name_with_role": "Stewart Maclennan",
                            "slug": "stewart-maclennan"
                        }
                    ],
                    "on_display": false,
                    "image": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/13132/7c5a6f2c2d76072f6c6e8690cc8d64242a5a35ae.jpg",
                    "material_desc": "wood engraving",
                    "credit_line": "Auckland Art Gallery Toi o Tāmaki, purchased 1977"
                }
            }, {
                "name": "Hampstead Heath (1977/71/2)",
                "type": "artwork",
                "id": "artwork-4850",
                "data": {
                    "id": 4850,
                    "slug": "hampstead-heath",
                    "name": "Hampstead Heath",
                    "artists": [
                        {
                            "id": "504",
                            "display_name": "Stewart Maclennan",
                            "display_name_with_role": "Stewart Maclennan",
                            "slug": "stewart-maclennan"
                        }
                    ],
                    "on_display": false,
                    "image": "https://artgallery-collection.cdn.aucklandunlimited.com/records/images/large/13134/5884d4be8c5c058d1bea05d1ad31429c05215246.jpg",
                    "material_desc": "lithograph",
                    "credit_line": "Auckland Art Gallery Toi o Tāmaki, purchased 1977"
                }
            }
        ],
        title: "Artwork",
        rows: 1
    },
    CONTENT_SET_PAGE: {
        items: [
            {
                "name": "Building",
                "type": "contentpage",
                "id": "contentpage-1",
                "data": {
                    "title_raw": "Building",
                    "section_video": null,
                    "theme_colour": null,
                    "publish_at": 1445551574000,
                    "thumbnail_image": "https://cdn.aucklandunlimited.com/artgallery/assets/media/about-building-thumb.jpg",
                    "section_donate": null,
                    "header_image": "",
                    "page_type": "content",
                    "slug": "building",
                    "uri": "/about/building",
                    "background_color": "black",
                    "section_about": null,
                    "section_faqs": null,
                    "theme_colour_secondary": null,
                    "subtitle": "A place for art",
                    "title": "Building",
                    "tags": [],
                    "is_published": true,
                    "id": 1,
                    "expires_at": null
                }
            },
            {
                "name": "Architecture",
                "type": "contentpage",
                "id": "contentpage-2",
                "data": {
                    "title_raw": "Architecture",
                    "section_video": [],
                    "theme_colour": null,
                    "publish_at": 1445554434000,
                    "thumbnail_image": "https://cdn.aucklandunlimited.com/artgallery/assets/media/building-architecture-thumb.jpg",
                    "section_donate": [],
                    "header_image": "",
                    "page_type": "content",
                    "slug": "architecture",
                    "uri": "/about/building/architecture",
                    "background_color": "black",
                    "section_about": [],
                    "section_faqs": [],
                    "theme_colour_secondary": null,
                    "subtitle": "",
                    "title": "Architecture",
                    "tags": [],
                    "is_published": true,
                    "id": 2,
                    "expires_at": null
                }
            },
            {
                "name": "Honour board",
                "type": "contentpage",
                "id": "contentpage-3",
                "data": {
                    "title_raw": "Honour board",
                    "section_video": null,
                    "theme_colour": null,
                    "publish_at": 1445556599000,
                    "thumbnail_image": "https://cdn.aucklandunlimited.com/artgallery/assets/media/about-honour-board-thumb.jpg",
                    "section_donate": null,
                    "header_image": "",
                    "page_type": "content",
                    "slug": "honour-board",
                    "uri": "/about/building/honour-board",
                    "background_color": "black",
                    "section_about": null,
                    "section_faqs": null,
                    "theme_colour_secondary": null,
                    "subtitle": "",
                    "title": "Honour board",
                    "tags": [],
                    "is_published": true,
                    "id": 3,
                    "expires_at": null
                }
            },
            {
                "name": "Māori commissions",
                "type": "contentpage",
                "id": "contentpage-4",
                "data": {
                    "title_raw": "Māori commissions",
                    "section_video": null,
                    "theme_colour": null,
                    "publish_at": 1445557116000,
                    "thumbnail_image": "https://cdn.aucklandunlimited.com/artgallery/assets/media/building-maori-commissions-thumb.jpg",
                    "section_donate": null,
                    "header_image": "",
                    "page_type": "content",
                    "slug": "maori-commissions",
                    "uri": "/about/building/maori-commissions",
                    "background_color": "black",
                    "section_about": null,
                    "section_faqs": null,
                    "theme_colour_secondary": null,
                    "subtitle": "",
                    "title": "Māori commissions",
                    "tags": [],
                    "is_published": true,
                    "id": 4,
                    "expires_at": null
                }
            }
        ],
        title: "Page",
        rows: 1
    },
    CONTENT_SET_EVENT: {
        items: [
            {
                "name": "Preview: Gordon Walters: New Vision",
                "type": "event",
                "id": "event-1265",
                "data": {
                    "booking_link": "",
                    "mainImage": "https://cdn.aucklandunlimited.com/artgallery/assets/media/gordon-walters-genealogy-5-1971-square.jpg",
                    "tags_disabled": [],
                    "tag_names": [
                        "Members"
                    ],
                    "is_featured": 0,
                    "event_type_hidden": [],
                    "editorial_tags_disabled": [],
                    "start_date": 1530835200000,
                    "name": "Preview: Gordon Walters: New Vision",
                    "slug": "preview-gordon-walters-new-vision",
                    "booking_link_text": null,
                    "artists": [],
                    "cost": "Members-only",
                    "thumbnailImage": "https://cdn.aucklandunlimited.com/artgallery/assets/media/gordon-walters-genealogy-5-1971-square.jpg",
                    "tags_hidden": [],
                    "editorial_tags": [],
                    "end_date": 1530849600000,
                    "time_summary": "12–4pm",
                    "location": "Level 1 exhibition spaces",
                    "curator": null,
                    "editorial_tags_hidden": [],
                    "tags": [],
                    "sponsors": [],
                    "short_description": "<p>Be one of the first people to enjoy <a href=\"https://www.aucklandartgallery.com/whats-on/exhibition/gordon-walters-new-vision\"><em>Gordon Walters: New Vision</em></a>,&nbsp;the first comprehensive survey of the artist&rsquo;s complete body of work.&nbsp;</p>",
                    "is_published": true,
                    "mobileImage": "",
                    "event_group": [],
                    "type": "event",
                    "id": 1265,
                    "event_type_disabled": [],
                    "description": "<h3>See it first. See it free.</h3>\r\n\r\n<p>Gordon Walters is one of New Zealand&rsquo;s most important modernist painters. Across six decades he explored the potential of a few simple geometric elements with a singular focus, creating works of exactitude and refinement.</p>\r\n\r\n<p><a href=\"/whats-on/exhibition/gordon-walters-new-vision\"><em>Gordon Walters: New Vision</em></a>&nbsp;is the first comprehensive survey of the artist&rsquo;s complete body of work.&nbsp; The original black and white koru paintings of the 1960s are shown alongside never-before-seen paintings, studies and notebooks.</p>\r\n\r\n<p>Gallery Members can see the exhibition before the crowds and enjoy a curator&rsquo;s talk at the exclusive Preview event.</p>\r\n\r\n<p>Not a Member?&nbsp;<a href=\"https://www.aucklandartgallery.com/give-and-join/membership/buy-membership\">Join today</a></p>\r\n\r\n<p>Present your valid membership card and photo ID at the membership desk to gain access to this Members-only preview.</p>",
                    "featured_order": 0,
                    "main_images": [
                        "https://cdn.aucklandunlimited.com/artgallery/assets/media/gordon-walters-genealogy-5-1971-square.jpg"
                    ],
                    "event_type": [
                        "members"
                    ],
                    "date_info": "<p>12&ndash;4pm</p>",
                    "artworks": []
                }
            },
            {
                "name": "Panel discussion: the making of Gordon Walters: New Vision",
                "type": "event",
                "id": "event-1266",
                "data": {
                    "booking_link": "",
                    "mainImage": "https://cdn.aucklandunlimited.com/artgallery/assets/media/gordon-walters-painting-j-1974.jpg",
                    "tags_disabled": [],
                    "tag_names": [
                        "Members",
                        "Talks and tours"
                    ],
                    "is_featured": 0,
                    "event_type_hidden": [],
                    "editorial_tags_disabled": [],
                    "start_date": 1530842400000,
                    "name": "Panel discussion: the making of Gordon Walters: New Vision",
                    "slug": "panel-discussion-the-making-of-gordon-walters-new-vision",
                    "booking_link_text": null,
                    "artists": [],
                    "cost": "Members-only",
                    "thumbnailImage": "https://cdn.aucklandunlimited.com/artgallery/assets/media/gordon-walters-painting-j-1974.jpg",
                    "tags_hidden": [],
                    "editorial_tags": [],
                    "end_date": 1530846000000,
                    "time_summary": "2pm",
                    "location": "Auditorium, lower ground level",
                    "curator": null,
                    "editorial_tags_hidden": [],
                    "tags": [],
                    "sponsors": [],
                    "short_description": "<p>As part of the Preview day for&nbsp;<em>Gordon Walters: New Vision</em>, enjoy a panel discussion with the exhibition co-curators &nbsp;Julia Waite (Auckland Art Gallery), Lucy Hammonds (Dunedin Public Art Gallery) and Professor Laurence Simmons (University of Auckland).</p>",
                    "is_published": true,
                    "mobileImage": "",
                    "event_group": [],
                    "type": "event",
                    "id": 1266,
                    "event_type_disabled": [],
                    "description": "<p>Auckland Art Gallery Toi o Tāmaki and Dunedin Public Art Gallery have partnered to present the major survey <a href=\"/whats-on/exhibition/gordon-walters-new-vision\"><em>Gordon Walters: New Vision</em></a>, an exhibition of more than 150 artworks. More than two years in the making, and with unprecedented access to the private archives of the Walters Estate, the exhibition examines the breadth of more than 50 years of Walters&rsquo; (1919&ndash;1995) work.</p>\r\n\r\n<p>Exhibition curators Julia Waite (Auckland Art Gallery), Lucy Hammonds (Dunedin Public Art Gallery) and Professor Laurence Simmons (University of Auckland) will touch upon the creation of this exhibition and share their experiences of the research into Walters&rsquo; practice in a panel discussion moderated by Auckland Art Gallery Director Rhana Devenport ONZM.</p>\r\n\r\n<p>Numbers limited, booking required.&nbsp;Members and Members guests only. RSVP required, please book through the Members enewsletter.</p>",
                    "featured_order": 0,
                    "main_images": [
                        "https://cdn.aucklandunlimited.com/artgallery/assets/media/gordon-walters-painting-j-1974.jpg"
                    ],
                    "event_type": [
                        "members",
                        "talks-and-tours"
                    ],
                    "date_info": "",
                    "artworks": []
                }
            },
            {
                "name": "Artist talk: Richard Killeen on Gordon Walters",
                "type": "event",
                "id": "event-1267",
                "data": {
                    "booking_link": "https://www.eventfinda.co.nz/2018/sunday-artist-talk-with-richard-killeen/auckland/tickets",
                    "mainImage": "https://cdn.aucklandunlimited.com/artgallery/assets/media/2018-richard-killeen.jpg",
                    "tags_disabled": [],
                    "tag_names": [
                        "Members",
                        "Talks and tours"
                    ],
                    "is_featured": 0,
                    "event_type_hidden": [],
                    "editorial_tags_disabled": [],
                    "start_date": 1536445800000,
                    "name": "Artist talk: Richard Killeen on Gordon Walters",
                    "slug": "artist-talk-richard-killeen-on-gordon-walters",
                    "booking_link_text": "Buy tickets",
                    "artists": [],
                    "cost": "$35 for Members, $85 for non-Members",
                    "thumbnailImage": "https://cdn.aucklandunlimited.com/artgallery/assets/media/2018-richard-killeen.jpg",
                    "tags_hidden": [],
                    "editorial_tags": [],
                    "end_date": 1536451200000,
                    "time_summary": "10.30am–12pm",
                    "location": "Members Lounge, level 2",
                    "curator": null,
                    "editorial_tags_hidden": [],
                    "tags": [],
                    "sponsors": [],
                    "short_description": "<p>Join us on for an exclusive talk between Curator, New Zealand Art Julia Waite and artist Richard Killeen in the beautiful Members Lounge overlooking Albert Park.</p>",
                    "is_published": true,
                    "mobileImage": "",
                    "event_group": [],
                    "type": "event",
                    "id": 1267,
                    "event_type_disabled": [],
                    "description": "<p>Join us on for an exclusive talk between Curator, New Zealand Art Julia Waite and artist Richard Killeen in the beautiful Members Lounge overlooking Albert Park. Renowned for his iconic &lsquo;cut outs&rsquo;, Killeen &ndash; like Gordon Walters &ndash; has had a profound impact on visual culture in New Zealand.</p>\r\n\r\n<p>The starting point for this discussion will be Killeen&rsquo;s first meeting with Walters in the early 1970s, and the effect of their long friendship on their practices. This is a rare opportunity to hear from one of New Zealand&rsquo;s most revered artists.</p>\r\n\r\n<p>Welcome with coffee, tea and croissants and pastries from 10.30am, followed by the discussion from 11am to 12pm.</p>\r\n\r\n<p>This is a fundraising event and the proceeds will benefit the programmes and activities of Auckland Art Gallery Toi o Tāmaki.</p>",
                    "featured_order": 0,
                    "main_images": [
                        "https://cdn.aucklandunlimited.com/artgallery/assets/media/2018-richard-killeen.jpg"
                    ],
                    "event_type": [
                        "members",
                        "talks-and-tours"
                    ],
                    "date_info": "<p>$35 for Members, $85 for non-Members (includes one-year Membership)<br />\r\nTickets include refreshments.</p>",
                    "artworks": []
                }
            },
            {
                "name": "Strike a Pose fashion films: The First Monday in May",
                "type": "event",
                "id": "event-1268",
                "data": {
                    "booking_link": "",
                    "mainImage": "https://cdn.aucklandunlimited.com/artgallery/assets/media/2018-the-first-monday-in-may.jpg",
                    "tags_disabled": [],
                    "tag_names": [
                        "Films",
                        "Members"
                    ],
                    "is_featured": 0,
                    "event_type_hidden": [],
                    "editorial_tags_disabled": [],
                    "start_date": 1538272800000,
                    "name": "Strike a Pose fashion films: The First Monday in May",
                    "slug": "strike-a-pose-fashion-films-the-first-monday-in-may",
                    "booking_link_text": null,
                    "artists": [],
                    "cost": "SOLD OUT",
                    "thumbnailImage": "https://cdn.aucklandunlimited.com/artgallery/assets/media/2018-the-first-monday-in-may.jpg",
                    "tags_hidden": [],
                    "editorial_tags": [],
                    "end_date": 1538280000000,
                    "time_summary": "3–5pm",
                    "location": "Auditorium, lower ground level",
                    "curator": null,
                    "editorial_tags_hidden": [],
                    "tags": [],
                    "sponsors": [
                        {
                            "link": "",
                            "logo": "sponsor1",
                            "designation": "",
                            "logoPath": "https://cdn.aucklandunlimited.com/artgallery/assets/media/docplay-logo.jpg"
                        },
                        {
                            "link": "",
                            "logo": "sponsor2",
                            "designation": "",
                            "logoPath": "https://cdn.aucklandunlimited.com/artgallery/assets/media/mindfood-style-logo.jpg"
                        },
                        {
                            "link": "",
                            "logo": "sponsor3",
                            "designation": "",
                            "logoPath": "https://cdn.aucklandunlimited.com/artgallery/assets/media/seedlip-logo-2018.jpg"
                        }
                    ],
                    "short_description": "<p>A robe can be an artist&rsquo;s muse, and intricately designed and beautifully made garments are works of art in their own right. We showcase the art of fashion with a new series of films about the fascinating fashion industry introduced by fashion expert Angela Lassig, who will put modern-day haute couture and street apparel in historic perspective.</p>",
                    "is_published": true,
                    "mobileImage": "",
                    "event_group": [],
                    "type": "event",
                    "id": 1268,
                    "event_type_disabled": [],
                    "description": "<h3>This screening is sold out</h3>\r\n\r\n<p>A robe can be an artist&rsquo;s muse, and intricately designed and beautifully made garments are works of art in their own right. We showcase the art of fashion with a series of films about the fascinating fashion industry introduced by fashion expert Angela Lassig, who will put modern-day haute couture and street apparel in historic perspective.</p>\r\n\r\n<p>This programme is supported by streaming platform <a href=\"https://www.docplay.com/\">DocPlay</a>, which offers a curated collection of thought-provoking documentaries from around the world.</p>\r\n\r\n<p>In the documentary <em>The First Monday in May</em> we closely follow the creation of <em>China: Through the Looking Glass</em>, the Metropolitan Museum of Art&#39;s most successful fashion exhibition to date.</p>",
                    "featured_order": 0,
                    "main_images": [
                        "https://cdn.aucklandunlimited.com/artgallery/assets/media/2018-the-first-monday-in-may.jpg"
                    ],
                    "event_type": [
                        "films",
                        "members"
                    ],
                    "date_info": "<p>3&ndash;5pm</p>",
                    "artworks": []
                }
            }
        ],
        title: "Event",
        rows: 1
    },
    HERO_ARTWORK: {
        "title": "Shane Cotton, Maunga",
        "details": "Drag your mouse and zoom into Shane Cotton's five story-high permanent artwork, Maunga that covers Excelsior House, corner of Customs Street East and Commerce Street.",
        "text_color": "#ffffff",
        "background_color": "#000000",
        "image": "https://cdn.aucklandunlimited.com/artgallery/assets/media/2020-shane-cotton-britomart-satellite-site-058a0868-hero-zoom-image-edit.jpg"
    },
    LARGE_THUMBNAIL: {
        "title": "Artworks | Mahi toi",
        "thumbnail_group": [
            {
                "title": "Ira Atua",
                "cta_text": "Learn more",
                "url": "https://www.aucklandartgallery.com/ira-atua",
                "image": "https://cdn.aucklandunlimited.com/artgallery/assets/media/2002-3-5-lisa-reihana-mahuika-colour-photographic-print-on-aluminium-2001-ira-atua-thumb-500px-v2.jpg",
                "description": "The celestial realm of the Gods"
            }, {
                "title": "Ira Tangata",
                "cta_text": "Learn more",
                "url": "https://www.aucklandartgallery.com/ira-tangata",
                "image": "https://cdn.aucklandunlimited.com/artgallery/assets/media/x2020-108-john-walsh-pare-to-my-place-ira-tangata-thumb-500px-v2.jpg",
                "description": "The terrestrial realm of humankind"
            }, {
                "title": "Commissions",
                "cta_text": "Learn more",
                "url": "https://www.aucklandartgallery.com/toi-tu-toi-ora-commissions",
                "image": "https://cdn.aucklandunlimited.com/artgallery/assets/media/sandy-adsett-commission-06-10-2020-thumb-500px.jpg",
                "description": "Major new artworks by artists from around Aotearoa New Zealand"
            }, {
                "title": "Satellite exhibition",
                "cta_text": "Learn more",
                "url": "https://www.aucklandartgallery.com/toi-tu-toi-ora-satellite-exhibition",
                "image": "https://cdn.aucklandunlimited.com/artgallery/assets/media/2020-shane-cotton-britomart-satellite-site-058a0868-thumb-500px.jpg",
                "description": "Toi Tu Toi Ora satellite site at Britomart"
            }
        ]
    },
    MENU_ITEM_NAV: {
        menuItems: [
            {
                "title": "Menu Item Nav",
                "slug": "menu-item-nav"
            },
            {
                "title": "Artists | Ringa toi",
                "slug": "artists-ringa-toi"
            },
            {
                "title": "Artworks | Mahi toi",
                "slug": "artworks-mahi-toi"
            },
            {
                "title": "Explore | Torohē",
                "slug": "explore-torohe"
            }, {
                "title": "Visit | Toro mai",
                "slug": "visit-toro-mai"
            }
        ]
    },
    MINIMALISTIC_VIDEO: {
        "video_url": "https://youtu.be/aEGLjiDJiqU",
        "description": "Free entry | Urunga kore utu",
        "title": "Open now | Tuwhera ināianei"
    },
    SWATCH: {
        items: [
            {
                title: 'Primary',
                colour: 'primary'
            }, {
                title: 'Secondary',
                colour: 'secondary'
            }
        ]
    },
    TEXT_PROPS: {
        content: '<h1>Main Text Content Heading</h1><p>Capitalize on low hanging fruit to identify a ballpark value added activity to beta test. Override the digital divide with additional clickthroughs from DevOps. Nanotechnology immersion along the information highway will close the loop on focusing solely on the bottom line.</p><p>Leverage agile frameworks to provide a robust synopsis for high level overviews. Iterative approaches to corporate strategy foster collaborative thinking to further the overall value proposition. Organically grow the holistic world view of disruptive innovation via workplace diversity and empowerment.</p><p>Bring to the table win-win survival strategies to ensure proactive domination. At the end of the day, going forward, a new normal that has evolved from generation X is on the runway heading towards a streamlined cloud solution. User generated content in real-time will have multiple touchpoints for offshoring.</p><blockquote><p>Sit amet, cu habeo accusamus sea, usu verear aliquam scaevola ea. Explicari definitionem vim ut. An has officiis convenire, ea eius ponderum suavitate.</p><em>Author&rsquo;s Name &ndash; Auckland Art Gallery</em></blockquote><p>Podcasting operational change management inside of workflows to establish a framework. Taking seamless key performance indicators offline to maximise the long tail. Keeping your eye on the ball while performing a deep dive on the start-up mentality to derive convergence on cross-platform integration.<p/><p>Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits. Dramatically visualize customer directed convergence without revolutionary ROI.</p><ul><li>Lorem Khaled Ipsum is a major key to success. They never said winning was easy. Some people can&rsquo;t handle success.</li><li>A major key, never panic. Don&rsquo;t panic, when it gets crazy and rough, don&rsquo;t panic, stay calm.</li><li>In life you have to take the trash out, if you have trash in your life, take it out, throw it away, get rid of it, major key</li><li>The weather is amazing, walk with me through the pathway of more success. Take this journey with me, Lion! Learning is cool, but knowing is better, and I know the key to success. Eliptical talk.</li></ul><p>Efficiently unleash cross-media information without cross-media value. Quickly maximize timely deliverables for real-time schemas. Dramatically maintain clicks-and-mortar solutions without functional solutions.<p/><p>Completely synergize resource taxing relationships via premier niche markets. Professionally cultivate one-to-one customer service with robust ideas. Dynamically innovate resource-leveling customer service for state of the art customer service.</p><a class="small primary button" href="/#">Button Text</a>'
    },
    TEXT_ASIDE_PROPS: {
        content: '<h1>Text with aside</h1><p>Lorem ipsum dolor sit amet, <strong>consectetur adipiscing elit</strong>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>',
        aside: '<p>Bring to the table win-win survival strategies to ensure proactive domination. At the end of the day, going forward, a new normal that has evolved from generation X is on the runway heading towards a streamlined cloud solution.</p><a class="small primary button" href="/#">Button Text</a>'
    },
    TEXT_QUOTE_PROPS: {
        content: '<h1>Text with quote</h1><p>Lorem ipsum dolor sit amet, <strong>consectetur adipiscing elit</strong>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>',
        quote: 'Sit amet, cu habeo accusamus sea, usu verear aliquam scaevola ea. Explicari definitionem vim ut. An has officiis convenire, ea eius ponderum suavitate.'
    },
    CAROUSEL: {
        items: [
            {
                title: 'Slide One Title',
                subtitle: 'Sit amet, cu habeo accusamus sea, usu verear aliquam scaevola ea. Explicari definitionem vim ut. An has officiis convenire, ea eius ponderum suavitate.',
                link: '#',
                file: 'https://picsum.photos/1640/900/?random',
                'text-color': 'white',
                'text-bg': 'black'
            }, {
                title: 'Slide Two Title',
                subtitle: 'Sit amet, cu habeo accusamus sea, usu verear aliquam scaevola ea. Explicari definitionem vim ut. An has officiis convenire, ea eius ponderum suavitate.',
                link: '#',
                file: 'https://picsum.photos/1640/901/?random',
                'text-color': 'white',
                'text-bg': 'red'
            }, {
                title: 'Slide Three Title',
                subtitle: 'Sit amet, cu habeo accusamus sea, usu verear aliquam scaevola ea. Explicari definitionem vim ut. An has officiis convenire, ea eius ponderum suavitate.',
                link: '#',
                file: 'https://picsum.photos/1640/902/?random',
                'text-color': 'black',
                'text-bg': 'yellow'
            }
        ]
    },
    IMAGE_CAROUSEL: {
        items: [
            {
                title: 'Summer Pops – Music From The Movies',
                file: 'https://unsplash.it/800/600',
                subtitle: 'Be swept away as the New Zealand Symphony Orchestra goes widescreen and takes you on a magical movie-themed adventure. Conducted by Associate Conductor Hamish McKeich, join us as we perform some of the most popular themes in movie history.',
                link: 'https://www.aucklandlive.co.nz/show/summer-pops-music-from-the-movies'
            },
            {
                title: 'Best Foods Comedy Gala',
                file: 'https://unsplash.it/800/601',
                subtitle: 'Hosted by crowd favourite Arj Barker, this year’s Best Foods Comedy Gala launches the 2018 NZ International Comedy Festival with one hell of an illustrious night of comedy.',
                link: 'https://www.aucklandlive.co.nz/show/best-foods-comedy-gala'
            },
            {
                title: 'The Nutcracker: Moscow Ballet Classique',
                file: 'https://unsplash.it/800/602',
                subtitle: 'La Classique was founded in 1990 by its current director, Elik Melikov. La Classique -  with its artistic ballet mastery, lavish costumes and magnificent stage sets -  will take us on a journey back in time to the frost-covered, gas-lit world of Clara, her beloved nutcracker doll and the magician Drosselmeyer.',
                link: 'https://www.aucklandlive.co.nz/show/the-nutcracker-moscow-ballet-classique'
            },
            {
                title: 'Postmodern Jukebox',
                file: 'https://unsplash.it/800/603',
                subtitle: 'Bringing their vintage twist on modern pop songs back to fans across the country, New Zealand loves Postmodern Jukebox. Following three successful tours in as many years, the multi-talented collective will bring their re-imagined contemporary pop, rock and R&B hits in the style of various yesteryears back to eagerly awaiting fans in 2018.',
                link: 'https://www.aucklandlive.co.nz/show/postmodern-jukebox'
            }, {
                title: 'Dinner In The Sky',
                file: 'https://unsplash.it/800/604',
                subtitle: 'For the first time, Dinner In The Sky is coming to New Zealand and you can be amongst the first to experience this truly unique dining experience this summer, next to The Cloud at Queens Wharf, Auckland.',
                link: 'https://www.aucklandlive.co.nz/show/dinner-in-the-sky'
            }
        ]
    },
    IMAGE_GALLERY_SINGLE: {
        items: [
            {
                creditline: '<p><strong>Image Two Title</strong></p><p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p><a href="#">Read more</a></p>',
                file: 'https://unsplash.it/800/600'
            }, {
                creditline: '<p><strong>Image One Title</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Excepteur sint occaecat cupidatat non proident.</p><p><a href="#">Read more</a></p>',
                file: 'https://unsplash.it/800/601'
            }
        ]
    },
    IMAGE_GALLERY_MULTIPLE: {
        items: [
            {
                creditline: '<p><strong>Image One Title</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>',
                file: 'https://unsplash.it/800/600'
            },
            {
                creditline: '<p><strong>Image Two Title</strong></p><p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
                file: 'https://unsplash.it/800/601'
            },
            {
                creditline: '<p><strong>Image Three Title</strong></p><p>Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
                file: 'https://unsplash.it/800/602'
            },
            {
                creditline: '<p><strong>Image Four Title</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
                file: 'https://unsplash.it/800/603'
            }, {
                creditline: '<p><strong>Image Five Title</strong></p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat id est laborum.</p>',
                file: 'https://unsplash.it/800/604'
            }, {
                creditline: '<p><strong>Image Six Title</strong></p><p>Labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat.</p>',
                file: 'https://unsplash.it/800/605'
            },
        ]
    },
    VIDEO: {
        data: {
            title: 'This is a title',
            video_url: 'https://www.youtube.com/watch?v=s2uY-CVyuX8',
            credit: 'Credit - Auckland Live',
            theme_colour: 'teal'
        }
    },
    PAGEBREAK_QUOTE_RED: {
        file: 'https://picsum.photos/id/1041/800/600',
        quote: 'Lorem ipsum dolor sit amet, cu habeo accusamus sea, usu verear aliquam scaev explicari definitionem vim ut.',
        cite: 'Author’s Name – Auckland Art Gallery',
        background: 'red'
    },
    PAGEBREAK_QUOTE_BLACK: {
        file: 'https://picsum.photos/id/1042/800/600',
        quote: 'Lorem ipsum dolor sit amet, cu habeo accusamus sea, usu verear aliquam scaev explicari definitionem vim ut.',
        cite: 'Author’s Name – Auckland Live',
        background: 'black'
    },
    PAGEBREAK_ALGORITHM_LEFT: {
        file: 'https://picsum.photos/id/1041/1200/600',
        background: 'red',
        location: 'left',
        left: 'cu\nques',
        right: 'ious\nion',
        algorithm_text: 'A curious question'
    },
    PAGEBREAK_ALGORITHM_RIGHT: {
        file: 'https://picsum.photos/id/1042/1200/600',
        background: 'black',
        location: 'right',
        left: 'cu\nques',
        right: 'ious\nion',
        algorithm_text: 'A curious question'
    },
    FAQ: {
        items: [
            {
                content: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Lorem ipsum dolor sit amet:</p><ul><li>Consectetur adipiscing elit.</li><li>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.&nbsp;</li><li>Ut enim ad minim veniam.</li></ul><p>Egestas pretium aenean pharetra magna ac. Iaculis eu non diam phasellus vestibulum. Lectus sit amet est placerat in egestas erat. Egestas integer eget aliquet nibh praesent tristique magna. Aliquet nibh praesent tristique magna sit. Ultricies mi eget mauris pharetra et ultrices. Nullam eget felis eget nunc lobortis. Feugiat scelerisque varius morbi enim nunc faucibus a. Convallis a cras semper auctor. Diam sollicitudin tempor id eu nisl nunc mi ipsum faucibus. Tellus id interdum velit laoreet id donec. Cursus in hac habitasse platea dictumst quisque sagittis purus. Ut morbi tincidunt augue interdum velit euismod in pellentesque massa. Nisl purus in mollis nunc. Feugiat nisl pretium fusce id velit ut tortor pretium viverra. Facilisis sed odio morbi quis commodo odio aenean sed. Volutpat blandit aliquam etiam erat velit scelerisque in. Ut morbi tincidunt augue interdum velit euismod in pellentesque. Fusce id velit ut tortor pretium viverra suspendisse potenti nullam. Sollicitudin nibh sit amet commodo nulla facilisi nullam vehicula. Non tellus orci ac auctor augue mauris augue neque gravida. Velit sed ullamcorper morbi tincidunt ornare massa eget egestas purus. Amet aliquam id diam maecenas ultricies mi eget. Id semper risus in hendrerit gravida. Scelerisque eu ultrices vitae auctor eu augue. Tortor posuere ac ut consequat semper viverra nam.</p>',
                heading: 'Frequently Asked Questions',
                title: 'Question with a big amount of content?'
            }, {
                content: '<p>Egestas pretium aenean pharetra magna ac. Iaculis eu non diam phasellus vestibulum. Lectus sit amet est placerat in egestas erat. Egestas integer eget aliquet nibh praesent tristique magna. Aliquet nibh praesent tristique magna sit. Ultricies mi eget mauris pharetra et ultrices. Nullam eget felis eget nunc lobortis. Feugiat scelerisque varius morbi enim nunc faucibus a. Convallis a cras semper auctor. Diam sollicitudin tempor id eu nisl nunc mi ipsum faucibus.</p>',
                heading: '',
                title: 'A question with a normal amount of content?'
            }, {
                content: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
                heading: '',
                title: 'A long question in words. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?'
            }, {
                content: '<p>Volutpat sed cras ornare arcu dui. Lacus luctus accumsan tortor posuere ac ut consequat. Nunc scelerisque viverra mauris in aliquam. Sit amet nulla facilisi morbi tempus iaculis urna id.</p>',
                heading: '',
                title: 'Another normal question?'
            }
        ]
    },
    FILE_DOWNLOAD: {
        id: "9654",
        display_name: "file",
        file: "https://assets.uat.tauweb.co.nz/artgallery/assets/media/zoo-edit.jpg",
        preview_image: "https://assets.uat.tauweb.co.nz/artgallery/assets/media/11834033-1170.jpeg",
        mimetype: "image/jpeg",
        filesize: "125739",
        filename: "zoo-edit.jpg",
        extension: "jpg"
    },
    STACKLA: {
        hash: "5a5e9bfef1852",
        id: "34888",
        subtitle: "stackla title",
        title: "Auckland Gallery"
    },
    GALLERY: {
        items: [
            {
                "file": "https://cdn.aucklandunlimited.com/artgallery/assets/media/aag-fd-web-rotator2.jpg",
                "creditline": "<p>credit line 1</p>"
            }, {
                "file": "https://cdn.aucklandunlimited.com/artgallery/assets/media/aag-rw-web-rotator-2284-x-800px.jpg",
                "creditline": "<p>credit line 2</p>"
            }
        ]
    },
    ROLLING_TEXT: {
        data: {
            title: "Become a Member today",
            rolling_group: [
                {
                    "text": "<p><strong>Standard Membership&nbsp;</strong></p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p><a class=\"small primary button\" href=\"https://www.aucklandartgallery.com/give-and-join/membership/buy-membership\" target=\"_blank\">BUY MEMBERSHIP</a></p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p>Standard Membership&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; $65<br />\r\nConcessions*&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;$55<br />\r\nGuest pass (limit one)&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; $25</p>\r\n\r\n<p>*Community Services Card holders, full-time students and seniors (65 years and over).&nbsp;Please bring proof of ID (Gold Card, student ID etc) when signing up.</p>\r\n\r\n<p>You can sign up at the membership desk in the Gallery or online. Either way, you&rsquo;ll receive a welcome pack including your membership card, a tote bag and information on benefits.<br />\r\nMemberships purchased at the Gallery are issued on the spot. If you purchase a Membership online, once your application has been processed, we&rsquo;ll post your welcome pack out to you.</p>\r\n\r\n<p>Online membership purchases are typically processed within 24 to 48 hours. Don&rsquo;t want to wait for the post? You can pick up your welcome pack from the Gallery. Just let us know by ticking the relevant box when you sign up.</p>\r\n\r\n<p>You will receive an email notification when your welcome pack is ready for pick up or is on the way to you in the post.</p>"
                }, {
                    "text": "<p><strong>Gift Membership&nbsp;</strong></p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p><a class=\"small primary button\" href=\"https://www.aucklandartgallery.com/give-and-join/membership/gift-membership\" target=\"_blank\">Buy a Gift Membership</a></p>\r\n\r\n<p>&nbsp;</p>\r\n\r\n<p>Gift standard&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;$65<br />\r\nGift concession *&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;$55<br />\r\nGift wrap + postcard&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; $5<br />\r\nGuest pass (limit one)&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;$25</p>\r\n\r\n<p>*Community Services Card holders, full-time students and seniors (65 years and over).&nbsp;Please bring proof of ID (Gold Card, student ID etc) when signing up.</p>\r\n\r\n<p>If the giftee is already an Auckland Art Gallery Member, their membership will be extended for one year. The giftee will receive a <strong>welcome pack including a complimentary tote bag</strong>, events programme and letter informing them about the extension of their membership. They can keep on using their existing membership card.</p>\r\n\r\n<p>If you choose the gift wrap + postcard option, we&rsquo;ll wrap the Members welcome pack, you can choose from one of the six artwork postcards below and we&rsquo;ll include a personal message from you to the recipient.</p>\r\n\r\n<p>Please choose from one of the artwork postcards below.&nbsp;</p>"
                }
            ]
        }
    },
    MEDIA: {
        data: {
            url: "https://www.youtube.com/watch?v=0iI7q5ebLps",
            oEmbed: "{\"title\":\"Walls to Live Beside, Rooms to Own: The Chartwell Show\",\"description\":\"Using the Chartwell Collection as a source, Walls to Live Beside, Rooms to Own is a response to our relationship to life at home \\u2013 one that has been signific...\",\"type\":\"video\",\"code\":\"<iframe width=\\\"200\\\" height=\\\"113\\\" src=\\\"https:\\\/\\\/www.youtube.com\\\/embed\\\/0iI7q5ebLps?feature=oembed\\\" frameborder=\\\"0\\\" allow=\\\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\\\" allowfullscreen title=\\\"Walls to Live Beside, Rooms to Own: The Chartwell Show\\\"><\\\/iframe>\",\"url\":\"https:\\\/\\\/www.youtube.com\\\/watch?v=0iI7q5ebLps\",\"authorName\":\"Auckland Art Gallery Toi o T\\u0101maki\",\"authorUrl\":\"https:\\\/\\\/www.youtube.com\\\/@aucklandartgallery\",\"providerName\":\"YouTube\",\"providerUrl\":\"https:\\\/\\\/www.youtube.com\\\/\",\"image\":\"https:\\\/\\\/i.ytimg.com\\\/vi\\\/0iI7q5ebLps\\\/hqdefault.jpg\",\"imageWidth\":480,\"imageHeight\":360,\"width\":200,\"height\":113,\"aspectRatio\":56.5}"
        }
    },
    DONATION1: {
        "suggestedAmounts": [
            "5", "10", "15", "20"
        ],
        "file": "https://cdn.aucklandunlimited.com/artgallery/assets/media/george-clausen-in-the-small-hours.jpg",
        "productId": "39988884570178",
        "no_overlay": "0",
        "content": "<p>donation content</p>"
    },
    DONATION2: {
        "suggestedAmounts": [
            "5", "10", "15", "20"
        ],
        "file": "https://cdn.aucklandunlimited.com/artgallery/assets/media/george-clausen-in-the-small-hours.jpg",
        "productId": "39988884570178",
        "no_overlay": "1",
        "content": "<p>donation content</p>"
    },
    SPONSOR: {
        items: [
            {
                "link": "https://www.aucklandartgallery.com/",
                "logo": "https://cdn.aucklandunlimited.com/artgallery/assets/media/aag-gg-exh-listing-thumb-1080x1080px-c.jpg",
                "designation": "designation"
            }
        ]
    }

};
